/* eslint-disable require-jsdoc */
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {isValid} from '../../utils/validate';


const Sort = (props) => {
  const [defaultSort, setDefaultSort] = useState(props.defaultSortValue);

  useEffect(() => {
    setDefaultSort(props.defaultSortValue);
  }, [props.defaultSortValue]);

  return (
    <div className="hearby-carousel-controls-item hearby-cci-sort">
      <select
        name="sort"
        className="hearby-cc-select-menu hearby-sort"
        onChange={props.change}

        value={defaultSort}
      >
        {/* {console.log('Sort.js props.defaultSortValue: ', props.defaultSortValue)}
        {console.log('Sort.js defaultSort: ', defaultSort)}
        {console.log('Sort.js props.change: ', props.change)} */}
        <option value="artist">Artist</option>
        <option value="venue">Venues</option>
        <option value="distance">Distance</option>
        <option value="date">Date</option>
      </select>
    </div>
  );
};

Sort.propTypes = {
  change: PropTypes.func.isRequired,
  defaultSortValue: PropTypes.string.isRequired,
};

export default Sort;
